module.exports = {
	"Search the video": "Buscar en el video",
	"Explore": "Explorar",
	"Print": "Imprimir",
	"Download": "Descargar",
	"Share": "Compartir",
	"Settings": "Configuración",
	"Language": "Idioma",
	"Interface Language": "Idioma de la Interfaz",
	"Transcript / Captions Language": "Idioma de la Transcripción / Subtítulos",
	"Transcript Language": "Idioma de la Transcripción",
	"Captions Language": "Idioma de los Subtítulos",
	"Show Transcript": "Mostrar Transcripción",
	"Show Captions": "Mostrar Subtítulos",
	"Show Heatmap": "Mostrar Mapa de Calor",
	"Show Speakers in Transcript": "Mostrar Oradores en la Transcripción",
	"Keyword": "Palabra Clave",
	"Keywords": "Palabras Clave",
	"Topic": "Tema",
	"Topics": "Temas",
	"Speaker": "Orador",
	"Speakers": "Oradores",
	"Transcript": "Transcripción",
	"Previous": "Anterior",
	"Next": "Siguiente",
	"Clear": "Limpiar",
	"No results found": "No hay resultados",
	"try another search or explore": "intentar otra búsqueda o explorar",
	"Share Search": "Compartir la búsqueda",
	"Share Time": "Compartir tiempo",
	"There is no transcript available in the selected language.": "No hay una transcripción diponible para el idioma seleccionado.",
	"Show {{count}} more": "Mostrar {{count}} más",
	"Show {{count}} more_plural": "Mostrar {{count}} más",
	"Captions": "Subtítulos",
	"Format": "Formato",
	"There is no transcript available for the current language.": "No hay una transcripción diponible para el idioma seleccionado.",
	"There are no captions available for the current language.": "No hay subtítulos disponibles para el idioma actual."
};


//////////////////
// WEBPACK FOOTER
// ./locale/es.json
// module id = ./locale/es.json
// module chunks = 0 1